let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("77XUT")).then(() => parcelRequire('eRtVx'));